import React, { useState, useEffect } from "react";
import ShopQuickNav from "./ShopQuickNav";

function ColorPlayLearnPage() {
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const allProducts = [
  {
    title: "Rainbow World Coloring Book",
    description: "Explore vibrant scenes with 30+ pages of creative fun!",
    image: "https://static.lumi.new/material/f7/f773d369b73699194647a78bfef81392.jpg",
    category: "coloring",
    isNew: true
  },
  {
    title: "My First ABC Activity Book",
    description: "Trace, color, and learn letters with playful activities!",
    image: "https://static.lumi.new/material/41/41ac3eb0cd4bf93bfd70c50075dd9bb9.jpg",
    category: "activity",
    isNew: true
  },
  {
    title: "Ocean Adventure Coloring Book",
    description: "Dive into underwater worlds with sea creatures and coral reefs!",
    image: "https://static.lumi.new/material/6e/6ec36cecc9dc3a93656b393daa10480f.jpg",
    category: "coloring",
    isNew: false
  },
  {
    title: "Numbers & Counting Activity Book",
    description: "Practice counting from 1 to 20 with fun games and puzzles!",
    image: "https://static.lumi.new/material/84/84acacda25cfddaca26e3d07abc27eed.jpg",
    category: "activity",
    isNew: false
  },
  {
    title: "Dinosaur Discovery Coloring Book",
    description: "Travel back in time and color amazing dinosaurs!",
    image: "https://static.lumi.new/material/e8/e85aeeb5fad7c24595d7e92a4b7c315b.jpg",
    category: "coloring",
    isNew: false
  },
  {
    title: "My Feelings Activity Book",
    description: "Learn about emotions with drawing and coloring activities!",
    image: "https://static.lumi.new/material/b0/b01a3cdb3af5ce9f75c6e152295afe7f.jpg",
    category: "activity",
    isNew: true
  },
  {
    title: "Space Explorer Coloring Book",
    description: "Blast off to the stars with rockets, planets, and astronauts!",
    image: "https://static.lumi.new/material/0b/0b0434516624ba43d176356e16bd8584.jpg",
    category: "coloring",
    isNew: false
  },
  {
    title: "Animal Friends Activity Book",
    description: "Meet farm and jungle animals with mazes, matching, and more!",
    image: "https://static.lumi.new/material/f1/f192dc764a68efd634673a20020212ac.jpg",
    category: "activity",
    isNew: false
  }];


  const filteredProducts = filter === "all" ?
  allProducts :
  allProducts.filter((product) => product.category === filter);

  return (
    <div className="min-h-screen bg-gradient-to-b from-sky-100 to-yellow-50">
      {/* Content */}
      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* Back Button */}
        <a
          href="/shop"
          className="inline-flex items-center gap-2 text-sky-600 hover:text-lime-500 font-bold text-xl mb-8 transition-colors duration-300"
          style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>

          ← Back to Kid's Shop
        </a>

        {/* Page Title */}
        <h2 className="text-4xl md:text-6xl font-black mb-8 text-center" style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
          <span className="text-sky-500 font-bold" style={{ fontSize: '90%' }}>🎨 Color, Play & Learn: The Complete Collection</span>
        </h2>

        {/* Quick Navigation Bar */}
        <ShopQuickNav />

        {/* Filter Dropdown */}
        <div className="mb-12">
          <label className="text-lg font-bold text-gray-700 block mb-3">Filter Activity Books by Category:</label>
          <select
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="px-6 py-3 rounded-full border-4 border-sky-400 bg-white font-bold text-gray-700 shadow-lg focus:outline-none focus:ring-4 focus:ring-sky-300 transition-all duration-300"
            style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>

            <option value="all">All</option>
            <option value="coloring">Coloring Books</option>
            <option value="activity">Activity Books</option>
          </select>
        </div>

        {/* Products Grid - 2 columns on mobile */}
        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {filteredProducts.map((product, index) =>
          <div
            key={index}
            className="group bg-white rounded-3xl shadow-lg overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-2xl border-6 border-sky-400 relative">

              {product.isNew &&
            <div className="absolute top-2 right-2 bg-red-500 text-white px-3 py-1 rounded-full font-bold text-xs shadow-lg z-10">
                  🆕 New
                </div>
            }
              <div className="p-4">
                <div className="aspect-square rounded-2xl overflow-hidden mb-3">
                  <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover" />

                </div>
                <h4 className="text-base md:text-xl font-bold text-gray-800 mb-2">{product.title}</h4>
                <p className="text-sm md:text-base text-gray-600 mb-3">{product.description}</p>
                <button className="w-full bg-coral-400 hover:bg-coral-500 text-white font-black py-2 md:py-3 px-4 rounded-full shadow-lg transform transition-all duration-300 hover:scale-105 active:scale-95 text-sm md:text-base">
                  Coming Soon
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>);

}

export default ColorPlayLearnPage;